import { Menu, MenuItem } from "@headlessui/react";
import React, { ReactNode } from "react";
import { cva } from "class-variance-authority";

const styles = cva(
  ["block w-full whitespace-nowrap", "px-4 py-2 text-left text-sm"],
  {
    variants: {
      active: {
        true: ["bg-gray-100"],
        false: [],
      },
      disabled: {
        true: ["opacity-50"],
        false: [""],
      },
    },
  },
);

export interface MenuItemButtonProps {
  children: ReactNode;
  className?: string;
  onClick: () => void;
  disabled?: boolean;
  preventDefault?: boolean;
  title?: string;
}

export function MenuItemButton({
  children,
  className,
  title,
  onClick,
  disabled,
  preventDefault,
}: MenuItemButtonProps) {
  const onClickWrapper = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    close: () => void,
  ) => {
    if (preventDefault) {
      e.preventDefault();
      close();
    }
    onClick();
  };
  return (
    <MenuItem>
      {({ focus, close }) => (
        <button
          disabled={disabled}
          title={title}
          type={"button"}
          onClick={(e) => onClickWrapper(e, close)}
          className={styles({ className, active: focus, disabled })}
        >
          {children}
        </button>
      )}
    </MenuItem>
  );
}
